{
  "localeInternationalCountryCode": "US",
  "PhoneInput": {
    "placeholder": "Enter phone number",
    "emptyDisplay": "-"
  },
  "CountryInput": {
    "placeholder": "Select country",
    "emptyCountries": "No countries found",
    "emptyDisplay": "-",
    "groupCommon": "Common",
    "groupAllCountries": "All Countries"
  },
  "VersionSwitch": {
    "ariaLabel": "Version",
    "beta": "Beta",
    "new": "New",
    "classic": "Classic",
    "switchBackAnytime": "Switch back anytime",
    "sendFeedback": "Send feedback",
    "feedbackDraft": "{{feature}} – feedback:",
    "switchedToNew": "Switched to the new version",
    "switchedToClassic": "Switched to the classic version",
    "undo": "Undo"
  }
}
